import { RegistrationTypeHelper } from '..';

export const useRegistrationType = () => {
	let registrationTypeHelper = new RegistrationTypeHelper();
	return {
		registrationTypeHelper,
		activeRegistrationType: registrationTypeHelper.active()
	};
};
